import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import type { AddLogingTrackingRequest } from 'api/security';

function useCreateLoginTrack() {
  const { showApiError } = useGlobalContext();
  const { security: securityApi } = useApiContext();
  const { t } = useTranslation('global');

  const { mutate, isLoading } = useMutation(
    (data?: AddLogingTrackingRequest) =>
      securityApi.loging.AddLoginTracking(data),
    {
      onError: (error) => {
        showApiError(
          error,
          t('common.commonMessages.genericRequestError'),
          3000
        );
      }
    }
  );

  return {
    createLoginTracking: mutate,
    iscreateLoginTrackingLoading: isLoading
  };
}

export default useCreateLoginTrack;
